import { useSuggestedNiches } from "queries";
import { NicheListWidgetAlive } from "components/widgets";
import { INiche } from "services/types";
import { routes } from "routes";

interface IProps {
  marginBottom?: boolean;
  page: number;
}

export const SuggestedNiches = ({ marginBottom, page }: IProps) => {
  const niches = useSuggestedNiches();

  if (niches.isError) {
    return <p>Error loading niches.</p>;
  }

  if (!niches.isSuccess || niches.data.length === 0) {
    return null;
  }

  const items = niches.data.map((el: INiche) => ({
    id: el.id,
    name: el.name,
    image: el.thumbnail,
    subscribers: el.subscribers,
  }));

  return (
    <NicheListWidgetAlive
      className="trendingBlock trendingNiches"
      title="⚡️ Suggested Niches"
      link={routes.niches()}
      niches={items}
      page={page}
    />
  );
};
